import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  standalone: false,
  name: 'BringozMap'
})
export class BringozMapPipe implements PipeTransform {
  transform(items: any[], field): any[] {
    return items.map(item => item[field]);
  }
}
